<template>
  <div
    class="h-full min-h-screen md:min-h-0 flex flex-col bg-black track"
    v-if="track"
  >
    <audio preload="none" :src="track.preview_url" ref="audio"></audio>
    <NavMenu :isDark="true" class="z-20" />
    <header class="px-5 py-10 flex items-start absolute z-20">
      <router-link
        class="w-15 h-15 cursor-pointer flex justify-center items-center"
        to="/search-tracks"
      >
        <Icon id="arrowLeft" />
      </router-link>
    </header>
    <div class="pb-8 md:pb-24 bg-black">
      <div class="relative mb-14 sm:mb-16">
        <div class="relative overflow-hidden min-h-33vh">
          <img
            class="
              absolute
              left-0
              -bottom-20
              mx-auto
              w-full
              z-0
              blur-2xl
              opacity-80
              filter
            "
            :src="track.images[0].url"
          />
          <img
            class="mx-auto w-full px-16 sm:px-36 relative z-10"
            :src="track.images[0].url"
          />
        </div>
        <div
          :style="{ background: themePrimaryColor }"
          @click="controlVideo"
          class="
            absolute
            w-24
            flex
            justify-center
            cursor-pointer
            items-center
            rounded-full
            h-24
            -bottom-12
            right-24
            md:right-40
            z-20
          "
        >
          <Icon :id="iconId" />
        </div>
      </div>
      <div class="px-16 sm:px-36 mb-24 text-lg">
        <p class="text-lg text-white text-left mb-2">{{ track.name }}</p>
        <span class="text-gray-300 text-left block">{{
          track.artist_name
        }}</span>
      </div>
      <div class="px-16 sm:px-36 text-white text-base" v-if="track?.spotify_id">
        <a class="flex mb-8 cursor-pointer" :href="spotifyUrl" target="_blank">
          <Icon id="spotify" /><span class="ml-4">
            {{ $t("trackSpotifyLink") }}
          </span>
        </a>
        <div class="flex cursor-pointer" @click="share">
          <Icon id="share" /><span class="ml-4">{{
            isCopied ? $t("trackShareCopied") : $t("trackShare")
          }}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { TranslationHandler } from '@/mixins/translation-handler'
import { RestTrack } from '@/types'
import { Component, Mixins } from 'vue-property-decorator'
import { Getter } from 'vuex-class'
import cms from '../../cms'
import { copyToClipboard } from '../../utils/copy'

@Component({
  components: {},
})
export default class Track extends Mixins(TranslationHandler) {
  @Getter campaignTracks!: RestTrack[]
  @Getter themePrimaryColor!: string

  $refs!: {
    audio: HTMLAudioElement,
  }

  iconId = 'play'
  isCopied = false

  mounted () {
    if (!this.$refs.audio) return

    this.$refs.audio.addEventListener('play', () => {
      this.iconId = 'pause'
    })
    this.$refs.audio.addEventListener('pause', () => {
      this.iconId = 'play'
    })
  }

  get spotifyUrl (): string|null {
    if (!this.track?.spotify_id) return null
    return `https://open.spotify.com/track/${this.track?.spotify_id}`
  }

  get track (): RestTrack|null {
    const trackId = parseInt(this.$route.params.id, 10)
    console.log('TRack ID', trackId)

    return this.campaignTracks.find((t) => t.id === trackId) || null
  }

  controlVideo ($event: Event) {
    $event.stopPropagation()

    if (this.$refs.audio.paused) {
      this.$refs.audio.play()
      return
    }

    this.$refs.audio.pause()
  }

  async share (): Promise<void> {
    const url = this.spotifyUrl
    if (!url) return

    if (navigator.share) {
      cms.tracking.trackSocial('social_share_start')
      try {
        await navigator.share({
          title: this.track?.name,
          url: url,
        })
        cms.tracking.trackSocial('social_share_success')
      } catch (e) {
        cms.tracking.trackSocial('social_share_fail', { error_message: (e as Error).toString() })
      }
    } else {
      try {
        copyToClipboard(url)
        this.isCopied = true
        cms.tracking.trackSocial('social_copy_link', { social_link: url })
      } catch (e) {
        console.log(e)
      }

      setTimeout(() => {
        this.isCopied = false
      }, 2000)
    }
  }
}
</script>
